import apisauce from "apisauce";

/**
 * API service — apisauce-based client matching the appointo_client pattern.
 */
export default {
  create: () => {
    const api = apisauce.create({
      baseURL: process.env.BASE_URL || "/api/v1",
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 30000,
    });

    // ---- Auth header helpers (same interface as appointo_client) ----

    const setAuthToken = (token) => {
      api.setHeader("Authorization", `Bearer ${token}`);
    };

    const removeAuthToken = () => {
      api.deleteHeader("Authorization");
    };

    return {
      // Helpers
      setAuthToken,
      removeAuthToken,

      // Auth
      login: (params) => api.post("auth/login", params),
      signup: (params) => api.post("auth/signup", params),
      me: () => api.get("users/me"),

      // Uploads
      presignUpload: (params) => api.post("uploads/presign", params),
      uploadToS3: (presignedUrl, file, contentType) =>
        fetch(presignedUrl, {
          method: "PUT",
          headers: { "Content-Type": contentType },
          body: file,
        }),

      // Dubbing Jobs
      createDubbingJob: (params) => api.post("dubbing_jobs", params),
      getDubbingJobs: () => api.get("dubbing_jobs"),
      getDubbingJob: (id) => api.get(`dubbing_jobs/${id}`),
      getDubbingJobStatus: (id) => api.get(`dubbing_jobs/${id}/status`),

      // Dubbing Outputs
      getDubbingOutputs: (jobId) => api.get(`dubbing_jobs/${jobId}/outputs`),
      downloadOutput: (jobId, outputId, type) =>
        api.get(`dubbing_jobs/${jobId}/outputs/${outputId}/download`, type ? { type } : {}),

      // Credits
      getBalance: () => api.get("credits/balance"),
      getPackages: () => api.get("credits/packages"),
      createCheckout: (params) => api.post("credits/checkout", params),
      getCreditHistory: () => api.get("credits/history"),

      // Estimate
      getEstimate: (params) => api.post("estimate", params),

      // Languages
      getLanguages: () => api.get("languages"),

      // Voices (ElevenLabs)
      getVoices: () => api.get("voices"),

      // API Keys
      getApiKeys: () => api.get("api_keys"),
      createApiKey: (params) => api.post("api_keys", params),
      deleteApiKey: (id) => api.delete(`api_keys/${id}`),
    };
  },
};
